
namespace RioERP.Orders {

    @Serenity.Decorators.registerClass()
    export class OrderProductBillingItemsGrid extends Serenity.EntityGrid<OrderProductBillingItemsRow, any> {
        protected getColumnsKey() { return OrderProductBillingItemsColumns.columnsKey; }
        protected getDialogType() { return OrderProductBillingItemsDialog; }
        protected getIdProperty() { return OrderProductBillingItemsRow.idProperty; }
        protected getInsertPermission() { return OrderProductBillingItemsRow.insertPermission; }
        protected getLocalTextPrefix() { return OrderProductBillingItemsRow.localTextPrefix; }
        protected getService() { return OrderProductBillingItemsService.baseUrl; }

        constructor(container: JQuery) {
            super(container);
        }
        protected addButtonClick() {

            this.editItem({ OrderId: this.OrderId });
        }

        protected usePager() {
            return false;
        }

        protected getGridCanLoad() {
            return this.OrderId != null;
        }

        private _OrderId: number;

        get OrderId() {
            return this._OrderId;
        }

        set OrderId(value: number) {
            if (this._OrderId != value) {
                this._OrderId = value;
                this.setEquality(OrderProductBillingItemsRow.Fields.OrderId, value);
                this.refresh();
            }
        }
        protected getButtons() {
            var buttons = super.getButtons();
            
            buttons.splice(0, 4);           

            return buttons;
        }
    }
}